<template>
    <div>
        <div class="text-14">
            <div class="tree absolute-y flex-column mt-20">

                <el-tree
                    ref="tree"
                    :data="treeData"
                    :props="defaultProps"
                    :load="loadNode"
                    :filter-node-method="filterNode"
                    @node-click="onClickNode"
                    @check-change="handleCheckChange"
                    class="filter-tree"
                    lazy
                    highlight-current
                    node-key="id"
                />

            </div>
            <components v-if="showBasic" :is="showBasic" class="absolute-y overflow-auto" style="left: 200px" />
            <div v-else class="absolute-y slef" style="left: 200px">
                <div v-for="(item, index) in srcList" :key="index + 'view'" class="absolute-all bg-default m-20">
                    <iframe :src="item" :frameborder="0" width="100%" height="20%" scrolling="no" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import basicAnnual from './basicAnnual/index';
import dailyReport from './dailyReport/index';

export default {
    components: {basicAnnual,dailyReport},
    data() {
        return {
            form: {},
            identityData: {},
            state: 1,
            src: '',
            showBasic: '',
            defaultProps: {
                label: 'name',
                isLeaf: 'leaf',
                children: 'children'
            },
            filterText: '',
            treeData: [], // 树数据
            srcList: [],

            urlData: {
                // url: this.$service.identity.tree.queryTreeByType + '?' + ,
            },
            time: '',
            downloadData: '',
            menuList: sessionStorage.getItem('selfMenu').split(',')
        };
    },
    computed: {},
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        downloadData(nval, oval) {
            let data = this.getcomplement(nval, oval) || [];
            if (data.length) {
                data.forEach((item, index) => {
                    this.$notify({
                        title: '提示',
                        message: `${item.fileName}可导出`,
                        duration: 2000,
                        type: 'success'
                    });
                });
            }
        }
    },
    mounted() {},
    created() {
        // this.init()
    },
    beforeDestroy() {
        clearInterval(this.time);
    },
    methods: {
        onClickNode(data) {
            this.showBasic = '';
            if (['dailyReport','basicAnnual'].includes(data.content)) {
                this.showBasic = data.content;
                return;
            }
            this.showBasic = false;
            this.src = data.content;
            if (data.content) {
                if (Array.isArray(data.content)) {
                    this.srcList = data.content;
                } else if (typeof data.content === 'string' && data.content.indexOf(',')) {
                    this.srcList = data.content.split(',');
                } else if (typeof data.content === 'string' && !data.content.indexOf(',')) {
                    this.srcList = [data.content];
                }
            }
        },
        handleCheckChange() {},
        search() {
        },
        caseChange(data) {
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                // 一级节点
                this.$http.get(this.$service.identity.tree.queryTreeByType + '?parentId=&type=reportQuery').then(res => {
                    this.treeData = res.data;
                    this.src = this.treeData[0].content;
                    if (this.treeData[0].content && Array.isArray(this.treeData[0].content)) {
                        this.srcList = this.treeData[0].content;
                    } else if (typeof this.treeData[0].content === 'string' && this.treeData[0].content.includes(',')) {
                        this.srcList = this.treeData[0].content.split(',');
                    } else if (typeof this.treeData[0].content === 'string' && !this.treeData[0].content.includes(',')) {
                        this.srcList = [this.treeData[0].content];
                    }

                    return resolve(Array.isArray(this.treeData) ? this.treeData : []);
                });
            }
            if (node.level > 0) {
                this.$http.get(this.$service.identity.tree.queryTreeByType + '?parentId=' + node.data.id + '&type=reportQuery').then(res => {
                    if (Array.isArray(res.data))
                        res.data.forEach(item => {
                            item.leaf = true;
                        });
                    return resolve(Array.isArray(res.data) ? res.data : []);
                });
            }
            // if(node.level>1 ){
            //     node.isLeaf = true
            //     node.leaf = true
            //     return resolve([])
            // }
            node.loaded = true;
            node.loading = false;
            this.$forceUpdate();
        },
        init() {
            const that = this;
            this.time = setInterval(function () {
                that.getData();
            }, 20000);
        },
        getcomplement(arr1, arr2) {
            if (!arr1 || !arr2) {
                return [];
            }
            return arr2.filter(temp => arr1.map(s => s.id).indexOf(temp.id) === -1);
        },
        getData() {
            if (!this.menuList.includes('export_file')) {
                return false;
            }
            let data = {};
            data.pageNum = 1;
            data.pageSize = 9999;
            data.type = '';
            this.$http.get(this.$service.comprehensiveQuery.exportFileManagement.getTableData, { params: data }).then(res => {
                if (res.message === '查询成功' || res.message === 'ok') {
                    this.downloadData = res.data.rows.filter(s => s.status != 'copy') || [];
                    if (this.downloadData.length === 0) {
                        clearInterval(this.time);
                    }
                } else {
                    clearInterval(this.time);
                }
            });
        }
    }
};
</script>
<style scoped lang="css">
.repart > .father {
	display: flex;
}
.repart > .father .son2 {
	flex: 1;
}
.slef {
	width: calc(100% - 200px);
}
.title {
	padding: 16px 27px;
}
.filter-tree {
	padding: 20px 0 0 20px;
	background-color: #fff;
}
.border-bottom {
	border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}
.fafa {
	height: 24px;
	width: 100%;
	background: rgba(241, 242, 244, 1);
}
.test333 {
	height: 98%;
}
.el-row {
	margin-bottom: 20px;
	/* &:last-child {
      margin-bottom: 0;
    } */
}
</style>
